/* TÖSTI: ambassadør-bios som runde knapper pr. overskrift. Klik folder teksten ud under knappen; vælges en ny knap, foldes den forrige ind igen (kun én åben ad gangen pr. ambassadør).
   28-09-2026: Kører nu på ALLE sider, hvor ambassadørerne er præsenteret (fx ambassadørsiden, All styles Women/Men) - på både computer og mobil.
   En blok genkendes som ambassadør-bio, når teksten har fede overskrifter og starter med "Sportsgren".
   Findes der mindst én bio på siden, får <body> klassen page-ambassadoerer, så stylingen i tosti-accordion.css også gælder der.
   02-10-2026: "Favorit produkt": links til de anbefalede produkter samles altid NEDERST under al teksten (aldrig midt i teksten).
   Har en blok ingen links (fx på Vores mission, All styles, 3 for 2), indsættes ambassadørens links fra listen FAV herunder.
   Ny ambassadør/andre favoritter: ret listen FAV (navnet matches på overskriften) - eller skriv links direkte i teksten. */
(function(){
  'use strict';
  var FAV = [
    ['jonathan', [['/products/tsw-heat-regulation-bamboo-t-shirt', 'Bambus T-shirt (Herre)']]],
    ['denis', [['/products/tsw-heat-regulation-bamboo-t-shirt', 'Bambus T-shirt (Herre)']]],
    ['rikke', [['/products/tsw-protect-sports-bra-medium-impact', 'The Protect Sports Bra (Medium Impact)'], ['/products/tsw-heat-regulation-bamboo-t-shirt-women', 'Bambus T-shirt (Dame)'], ['/products/tsw-heat-regulation-bamboo-long-sleeve', 'Bambus Long Sleeve (Dame)']]],
    ['may mogensen', [['/products/high-impact-sports-bh', 'High Impact Sportsbh'], ['/products/tsw-eco-breathe-tights', 'Tights (Dame)']]],
    ['sophie', [['/products/tsw-heat-regulation-bamboo-long-sleeve', 'Bambus Long Sleeve (Dame)'], ['/products/tsw-eco-breathe-shorts', 'Shorts (Dame)']]],
    ['magnus', [['/products/tsw-eco-luxe-recovery-joggers-unisex', 'Joggers (Unisex)'], ['/products/tsw-heat-regulation-bamboo-t-shirt', 'Bambus T-shirt (Herre)']]],
    ['alexander', [['/products/tsw-heat-regulation-bamboo-t-shirt', 'Bambus T-shirt (Herre)']]]
  ];
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function stripEdge(html){
    var s = html;
    for(var i = 0; i < 30; i++){
      var next = s.replace(/^(?:\s|&nbsp;|<br\s*\/?>)+/i, '').replace(/(?:\s|&nbsp;|<br\s*\/?>)+$/i, '');
      if(next === s) break;
      s = next;
    }
    return s.trim();
  }
  function cleanLabel(html){
    var s = html.replace(/<br\s*\/?>/gi, ' ').replace(/&nbsp;/g, ' ');
    s = s.replace(/<[^>]+>/g, '');
    s = s.replace(/\s+/g, ' ').trim();
    s = s.replace(/:\s*$/, '');
    return s;
  }
  function parseFields(html){
    var re = /<(strong|b)(?:\s[^>]*)?>([\s\S]*?)<\/\1>([\s\S]*?)(?=<(?:strong|b)(?:\s[^>]*)?>|$)/gi;
    var fields = [], m;
    while((m = re.exec(html))){
      var label = cleanLabel(m[2]);
      var body = stripEdge(m[3].replace(/<\/?p[^>]*>/gi, '<br>'));
      if(label) fields.push({label: label, body: body});
    }
    return fields;
  }
  /* Favorit produkt: tag produktlinks ud af teksten og sæt dem samlet nederst */
  function favLinksFor(name){
    var n = (name || '').toLowerCase();
    for(var i = 0; i < FAV.length; i++){ if(n.indexOf(FAV[i][0]) > -1) return FAV[i][1]; }
    return [];
  }
  function fixFavorite(body, name){
    var links = [], seen = {};
    body = body.replace(/<a\b[^>]*href="([^"]*\/products\/[^"]*)"[^>]*>([\s\S]*?)<\/a>/gi, function(m, href, txt){
      var t = txt.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
      if(!seen[href]){ seen[href] = 1; links.push([href, t]); }
      return '';
    });
    /* Rester af skilletegn mellem de fjernede links (" · ") og for mange linjeskift */
    body = body.replace(/(<br\s*\/?>)(?:\s|&nbsp;|&middot;|·)+(?=<br|$)/gi, '$1');
    body = body.replace(/^(?:\s|&nbsp;|&middot;|·)+(?=<br|$)/i, '');
    body = body.replace(/(?:<br\s*\/?>\s*){3,}/gi, '<br><br>');
    body = stripEdge(body);
    if(!links.length) links = favLinksFor(name);
    if(!links.length) return body;
    var html = '<span class="tosti-fav-links">';
    for(var i = 0; i < links.length; i++) html += '<a href="' + esc(links[i][0]) + '">' + esc(links[i][1]) + '</a>';
    return body + html + '</span>';
  }
  function isBio(content){
    var first = content.querySelector('strong, b');
    return !!(first && /^\s*sportsgren/i.test(first.textContent || ''));
  }
  function setupBlock(g){
    var content = g.querySelector('.image-with-text--content.rte');
    var h2 = g.querySelector('h2');
    if(!content || !h2) return;
    if(!isBio(content)) return;
    /* Bioerne er skrevet forskelligt: nogle ligger i ét <p>, andre er delt i flere <p>-afsnit.
       Vi samler ALLE afsnit før vi leder efter fede overskrifter, så intet indhold mistes. */
    var ps = content.querySelectorAll('p');
    if(!ps.length) return;
    var raw = Array.prototype.map.call(ps, function(x){ return '<p>' + x.innerHTML + '</p>'; }).join('');
    var fields = parseFields(raw);
    if(!fields.length) return;
    g.__tostiAcc2 = 1;
    document.body.classList.add('page-ambassadoerer');
    var name = h2.textContent || '';
    var teaser = fields.shift();
    var out = '';
    if(teaser && teaser.body) out += '<p class="tosti-acc2__teaser"><strong>' + teaser.label + ':</strong> ' + teaser.body + '</p>';
    out += '<div class="tosti-acc2">';
    for(var k = 0; k < fields.length; k++){
      var body = fields[k].body;
      if(/favorit/i.test(fields[k].label)) body = fixFavorite(body, name);
      out += '<div class="tosti-acc2__item">' +
        '<button type="button" class="tosti-acc2__btn" aria-expanded="false">' + fields[k].label + '</button>' +
        '<div class="tosti-acc2__panel" hidden><p>' + body + '</p></div>' +
        '</div>';
    }
    out += '</div>';
    content.innerHTML = out;
    var items = content.querySelectorAll('.tosti-acc2__item');
    items.forEach(function(item){
      var btn = item.querySelector('.tosti-acc2__btn');
      var panel = item.querySelector('.tosti-acc2__panel');
      btn.addEventListener('click', function(){
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function(it){
          it.classList.remove('is-open');
          it.querySelector('.tosti-acc2__btn').setAttribute('aria-expanded', 'false');
          it.querySelector('.tosti-acc2__panel').hidden = true;
        });
        if(!wasOpen){
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }
  function build(){
    if(!document.body) return;
    var blocks = document.querySelectorAll('.featured-content .grid');
    blocks.forEach(function(g){
      if(g.__tostiAcc2) return;
      setupBlock(g);
    });
  }
  var n = 0, iv = setInterval(function(){ build(); if(++n > 60) clearInterval(iv); }, 250);
  document.addEventListener('DOMContentLoaded', build);
  window.addEventListener('load', build);
})();
